import { object } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import "@lib/messageComposition/chatMessaging/yupHelper";

import { getRcsFallbackMessageSchema } from "./rcsFallbackMessageSchema";
import { getRcsSuggestionSchema } from "./suggested_actions";

export const getRcsActionsSchema = (t: I18nT<"rcs-composer">) =>
  object({
    actions: getRcsSuggestionSchema(t).optional(),
  });

export const getRcsBaseSchema = (t: I18nT<"rcs-composer">) =>
  object({}).concat(getRcsFallbackMessageSchema(t)).noUnknown();
